import { userConstants } from "../../constant";

const initialState = {
  estimates: [],
  effective_weight_kg: null,
  product_slug: null,
  destination: null,
  loading: false,
  error: null,
  // Admin rates
  rates: [],
  ratesLoading: false,
};

export function shippingEstimate(state = initialState, action) {
  switch (action.type) {
    case "SHIPPING_ESTIMATE_LOADING":
      return { ...state, loading: true, error: null };
    case userConstants.GET_SHIPPING_ESTIMATE:
      return {
        ...state,
        loading: false,
        estimates: action.payload.estimates || [],
        effective_weight_kg: action.payload.effective_weight_kg || null,
        product_slug: action.payload.product_slug || null,
        destination: action.payload.destination || null,
        error: action.payload.message && action.payload.estimates?.length === 0
          ? action.payload.message
          : null,
      };
    case "SHIPPING_ESTIMATE_ERROR":
      return { ...state, loading: false, error: action.payload, estimates: [] };
    case userConstants.CLEAR_SHIPPING_ESTIMATE:
      return { ...initialState, rates: state.rates, ratesLoading: state.ratesLoading };

    // Admin shipping rates
    case "ADMIN_SHIPPING_RATES_LOADING":
      return { ...state, ratesLoading: true };
    case userConstants.GET_ADMIN_SHIPPING_RATES:
      return { ...state, ratesLoading: false, rates: action.payload || [] };
    case userConstants.CREATE_SHIPPING_RATE:
      return { ...state, rates: [...state.rates, action.payload] };
    case userConstants.UPDATE_SHIPPING_RATE:
      return {
        ...state,
        rates: state.rates.map((r) =>
          r.id === action.payload.id ? action.payload : r
        ),
      };
    case userConstants.DELETE_SHIPPING_RATE:
      return {
        ...state,
        rates: state.rates.filter((r) => r.id !== action.payload),
      };
    default:
      return state;
  }
}
